import React, { useContext, useEffect, useState } from "react";
import LensItemCreation from "../../../API/APIServices/LensItemCreation";
import Swal from "sweetalert2";

const OptionalFields = () => {
  const [masterType, setMasterType] = useState(0);
  const [fieldData, setfieldData] = useState([
    {
      masterType: masterType || 0,
      optionalFieldName: "",
      ef1: "string",
      ef2: "string",
      ef3: "string",
      isDeleted: false,
      isActive: true,
    },
  ]);

  const [FieldCount, setFieldCount] = useState(fieldData.length);

  const CreateTableinputs = (e) => {
    setFieldCount(e.target.value);
    var value = e.target.value;
    if (value > 0 && value <= 100) {
      var temp = [];
      for (var i = 0; i < value; i++) {
        temp.push({
          masterType: masterType || 0,
          optionalFieldName: "",
          ef1: "string",
          ef2: "string",
          ef3: "string",
          isDeleted: false,
          isActive: true,
        });
      }
      setfieldData(temp);
    }
  };

  const mastertypeSet = (e) => {
    const selectedValue = e.target.value;
    setMasterType(selectedValue);
    const updatedFieldData = fieldData.map((item) => ({
      ...item,
      masterType: selectedValue,
    }));
    setfieldData(updatedFieldData);

    getOptionalFields(selectedValue);
  };

  const handleInputChange = (e, index) => {
    const { value } = e.target;
    const updatedFieldData = [...fieldData];
    updatedFieldData[index].optionalFieldName = value;
    setfieldData(updatedFieldData);
  };

  useEffect(() => {
    console.log("fieldData", fieldData);
    console.log("masterType", masterType);
  }, [masterType, fieldData]);

  const saveOptFields = async () => {
    if (
      fieldData.length == 0 &&
      fieldData[0].optionalFieldName == "" &&
      fieldData[0].masterType == 0
    ) {
      Swal.fire({
        timer: 3000,
        title: "Error",
        text: "Please enter the number of extra fields",
        icon: "error",
        confirmButtonText: "OK",
        timerProgressBar: true,
        width: "350px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
      return;
    }
    if (masterType == 0) {
      Swal.fire({
        timer: 3000,
        title: "Error",
        text: "Please select a master category",
        icon: "error",
        confirmButtonText: "OK",
        timerProgressBar: true,
        width: "350px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
      return;
    }
    var data = await LensItemCreation.CreateLensPowerOptionalField(
      fieldData,
      masterType
    );
    if (data) {
      Swal.fire({
        timer: 3000,
        title: "Success",
        text: "Data saved successfully",
        icon: "success",
        confirmButtonText: "OK",
        timerProgressBar: true,
        width: "350px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setfieldData([
            {
              masterType: masterType || 0,
              optionalFieldName: "",
              ef1: "string",
              ef2: "string",
              ef3: "string",
              isDeleted: false,
              isActive: true,
            },
          ]);
        }
      });
    } else {
      Swal.fire({
        timer: 3000,
        title: "Error",
        icon: "warning",
        confirmButtonText: "OK",
        timerProgressBar: true,
        width: "350px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
    }
  };

  const handleDelete = async (index) => {
    
    var DeleteData = [index];
    var data = await LensItemCreation.DeleteLensPowerOptionalFieldsByIds(
      DeleteData
    );
    if (data) {
      Swal.fire({
        timer: 3000,
        title: "Success",
        text: "Data deleted successfully",
        icon: "success",
        confirmButtonText: "OK",
        timerProgressBar: true,
        width: "350px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
      await getOptionalFields(masterType);
    } else {
      Swal.fire({
        timer: 3000,
        title: "Error",
        icon: "warning",
        confirmButtonText: "OK",
        timerProgressBar: true,
        width: "350px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
    }
  };

  const getOptionalFields = async (masterType) => {
    var data = await LensItemCreation.GetLensPowerOptionalField(masterType);
    if (data) {
      setfieldData(data);
      setFieldCount(data.length);
    } else {
      setfieldData([
        {
          masterType: masterType || 0,
          optionalFieldName: "",
          ef1: "string",
          ef2: "string",
          ef3: "string",
          isDeleted: false,
          isActive: true,
        },
      ]);
    }
  };

  return (
    <div className="PopupAndSearchCondition-box">
      <div className="Optional_field_mainbox">
        <p className="Optional_field_heading">Extra Fields Details</p>

        <div className="Optional_field_topbox">
          <p className="Optional_field_heading2">Select Master Category :</p>
          <select
            className="Optional_field_selectbox"
            onChange={(e) => mastertypeSet(e)}
          >
            <option value="0">---Select---</option>
            <option value="2">Account</option>
            <option value="4">Item</option>
            <option value="7">Lens Trace Info</option>
            <option value="6">Material Centre</option>
          </select>
          <div></div>
        </div>

        <div className="Optional_field_middlebox">
          <p className="Optional_field_heading2">
            Enter Number Of Extra Field :
          </p>
          <input
            className="Optional_field_input"
            type="text"
            value={FieldCount}
            placeholder="Enter Number of Extra Fields"
            onChange={(e) => CreateTableinputs(e)}
          />
          <button className="Optional_field_button">Default lens Fields</button>
        </div>

        <div className="Optional_field_lastbox">
          <table className="Optional_field_table">
            <thead>
              <tr>
                <td>S NO</td>
                <td>Field Name</td>
                <td>
                  {" "}
                  <i
                    className="Optional_field_DeleteBtn"
                    class="fa-solid fa-trash"
                  ></i>
                </td>
              </tr>
            </thead>
            <tbody>
              {fieldData.map((item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>
                    <input
                      onChange={(e) => handleInputChange(e, index)}
                      type="text"
                      value={item.optionalFieldName}
                    />
                  </td>
                  <td>
                    <i
                      className="Optional_field_DeleteBtn"
                      class="fa-solid fa-trash"
                      onClick={() => handleDelete(item)}
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button onClick={saveOptFields} className="Optional_field_savebtn">
          Save Fields
        </button>
      </div>
    </div>
  );
};

export default OptionalFields;
